import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed,
} from '@angular/core';

@Component({
  selector: 'ss-icon',
  imports: [CommonModule],
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss'],
  host: {
    '[style.pointer-events]': 'myStyle()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIconComponent {
  icon = input<string>();
  iconalt = input<string>();
  removeBackground = input<boolean>(false);
  disabled = input<boolean | undefined>(false);
  disabledhover = input<boolean>(false);
  backgroundType = input<string>();
  myStyle = computed(() => (this.disabled() ? 'none' : undefined));
}
